<template>
  <div class="white-container full-page-container common-table">
    <div class="operation-table">
      <tableList ref="multipleTable" size="small" :query-function="$Api.operation.postOperationLog" style="width: 100%">
        <el-table-column prop="id" label="日志ID" />
        <el-table-column prop="name" label="操作人员" width="auto" />
        <el-table-column prop="account" label="操作账号" width="auto" />
        <el-table-column prop="operation" label="操作内容" width="auto" />
        <el-table-column prop="requestPath" label="请求路径" width="auto" />
        <el-table-column prop="requestBody" label="请求参数" width="100">
          <template v-slot="{row}">
            <el-popover placement="top-end" title="Body" width="auto" trigger="hover" :content="row.requestBody ? row.requestBody: '--'">
              <span slot="reference" style="margin-right:10px;">Body</span>
            </el-popover>
            <el-popover placement="top-start" title="Param" width="auto" trigger="hover" :content="row.requestParam? row.requestParam: '--'">
              <span slot="reference">Param</span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="response" label="响应结果" width="120">
          <template v-slot="{row}">
            <el-button v-if="row.response" type="text" size="small" @click="handleView(row.response)">点击查看</el-button>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="操作时间" width="150px">
          <template v-slot="{row}">
            {{ formatTime(row.createTime) }}
          </template>
        </el-table-column>
      </tableList>
      <el-dialog v-if="showDialog" :visible.sync="showDialog" custom-class="response-wrapper" title="响应结果">
        <div class="box">{{ currentRow }}</div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import tableList from '@/components/TableList';
import moment from 'moment';
export default {
  components: { tableList },
  data() {
    return {
      currentRow: null,
      showDialog: false,
    };
  },

  methods: {
    formatTime(val) {
      if (val) return moment(val).format('YYYY/MM/DD HH:mm:ss');
      return '';
    },
    handleView(data) {
      this.currentRow = data;
      this.showDialog = true;
    },

  },
};
</script>
<style lang="less" scoped>
.operation-table {
  .response-wrapper {
    .box {
      max-height: 500px;
      font-family: "Noto Sans SC";
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      overflow-y: scroll;
      line-height: 20px;
    }
  }
}
</style>

